import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { ConfirmForm, Input, LoginFooter } from 'components';
import { Button, Text } from 'components';
import loginImage from 'assets/loginImage.png';
import axios from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';

const ResetEmail = () => {
  const [email, setEmail] = useState<string>('');
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const [headerText, setHeaderText] = useState<string>('Forgot Password');
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false); 
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const emailRegexp = new RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g);
  const nav = useNavigate();

  useEffect(() => {
    if(email && emailRegexp.test(email)){
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
    setErrorMessage(null);
  }, [email]);

  const onClickEmailButton = async () => {
    if (!isButtonDisabled) {
      try {
        const res = await axios.post(`/api/member/passwordResetStart`, {
          email
        });
        setIsEmailSent(true); // 텍스트 변경
        console.log('re', res);
      } catch (error) {
        console.error('Password reset error:', error);
  
        if (axios.isAxiosError(error)) {
          const method = error.response?.data?.method;
  
          if (method === 'SOCIAL_LOGIN_TRY') {
            setErrorMessage('This email is associated with a social login. Please try signing in using your social account.');
          } else {
            setErrorMessage('Failed to send password reset email. Please check your email address and try again.');
          }
        } else {
          setErrorMessage('An unexpected error occurred. Please try again later.');
        }
      }
    }
  };
  

  const onClickHomeButton = () => {
    nav('/login');
  };

  return (
    <div className="flex h-screen max-h-screen w-screen flex-col bg-white">
      <main className="flex w-full flex-1 items-center justify-center">
        <div className="flex w-100 flex-col items-center">
          {!isEmailSent ? (
            <Text className="mb-4" size="heading2" weight="medium">
            Forgot Password
            </Text> 
          ) : (
            <Text className="mb-4" size="heading2" weight="medium">
            Reset password
          </Text> 
          )}
          {!isEmailSent ? (
            <Text className="mb-6" size="body1" weight="regular">
              Please enter the email address you registered when signing up.
            </Text>
          ) : (
            <Text className="mb-6 text-center" size="body1" weight="regular">
              We&apos;ve sent an email.<br/>An email has been sent to reset your password.<br/>
              If you haven&apos;t received the email, please check if your email address is correct.
            </Text>
          )}
          <div className="flex w-80 flex-col items-center">
            <form className="mb-6 flex w-full flex-col gap-6">
              <Input
                inputClassName="bg-white h-10"
                label="Email"
                type="text"
                placeholder='Enter your email address'
                value={email}
                setValue={setEmail}
                errorMessage={errorMessage}
              />
            </form>
            {!isEmailSent ?(
            <Button
              className="h-10 w-full items-center justify-center"
              text="Continue"
              type="blue"
              disabled={isButtonDisabled}
              onClick={onClickEmailButton}
            />) : (
              <Button
              className="h-10 w-full items-center justify-center"
              text="Return to Login"
              type="blue"
              onClick={onClickHomeButton}
            />
            )
          }
          </div>
        </div>
      </main>
      <LoginFooter />
    </div>
  );
};

export default ResetEmail;
